//Import contact from CSV file

import React, { useState } from 'react';
import { Button, Input, Modal, Table, Text } from '@nextui-org/react';
import { toast } from 'react-toastify';
import { auth, firestore } from '../config/firebase';
import { collection, doc, setDoc } from "firebase/firestore";

const ImportButton = () => {
    var XLSX = require('xlsx');
    const [visible, setVisible] = useState(false);
    const [file, setFile] = useState(null);
    const [fileLoaded, setFileLoaded] = useState(false);
    const [contacts, setContacts] = useState([]);
    const [loading, setLoading] = useState(false);
    const handler = () => setVisible(true);

    const handleFile = (e) => {
        const file = e.target.files[0];
        setFile(file);
    }

    const handleImport = () => {
        const reader = new FileReader();
        reader.onload = (e) => {
            const data = e.target.result;
            const workbook = XLSX.read(data, { type: 'binary' });
            //Transforme les noms de colonnes en name et phone
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const json = XLSX.utils.sheet_to_json(sheet);
            const contacts = json.map((contact) => {
                return {
                    name: contact.Nom,
                    phone: contact.Numero,
                }
            });
            setFileLoaded(true);
            setContacts(contacts);
            setFile(null);
            toast.success('Fichier importé avec succès');
        };
        reader.readAsBinaryString(file);
        handleValidateToFirebase();

    }

    const handleValidateToFirebase = () => {
        try {
            const subCollectionRef = collection(firestore, "users", auth.currentUser.uid, "contacts")
            contacts.forEach((contact) => {
                setLoading(true);
                const docRef = doc(subCollectionRef);
                //Pour chaque contact, on enregistre dans firebase dans un document
                    setDoc(docRef, {
                        name: contact.name,
                        phone: contact.phone,
                    });
            });

            toast.success('Contacts importés avec succès');
            setVisible(false);
            setLoading(false);
            setFileLoaded(false);
            
        } catch (e) {
            console.log(e)
        }

    }

    return (
        <>
            <Button
                color="secondary"
                auto
                onClick={handler}
                css={{ width: '100%' }}
            >
                Importer
            </Button>
            <Modal closeButton aria-labelledby='Popup enregistrement contact' open={visible} onClose={() => {setVisible(false); setFile(null)}}>
                <Modal.Header>
                    <Text b size={18}>
                        Importer des contacts
                    </Text>
                </Modal.Header>
                <Modal.Body>
                {
                    file ? (
                        <>
                            <Button
                                color="secondary"
                                auto
                                onClick={handleImport}
                            >
                                Lancer l'importation
                            </Button>
                        </>
                    ) : (
                        <>
                            <Text size={14}>
                                Pour importer des contacts, veuillez choisir un fichier au format XLSX. Dont les colonnes sont nommées <Text b>"Nom"</Text> et <Text b>"Numero"</Text>.
                            </Text>
                            <Input
                                css={{ width: '100%' }}
                                clearable
                                bordered
                                label="Fichier"
                                placeholder="Choisir un fichier"
                                color="primary"
                                size="lg"
                                type={'file'}
                                onChange={(e) => handleFile(e)}
                            />
                        </>
                    )
                }
                </Modal.Body>
                <Modal.Footer>
                    <Button auto onClick={() => {setVisible(false); setFile(null)}}>
                        Fermer
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ImportButton